var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_9650)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 17.8854L23.5428 25.428C23.7942 25.6709 24.131 25.8053 24.4806 25.8023C24.8302 25.7992 25.1646 25.659 25.4118 25.4118C25.6591 25.1646 25.7993 24.8302 25.8023 24.4806C25.8054 24.131 25.671 23.7942 25.4281 23.5427L17.8854 16L25.4281 8.45737C25.671 8.2059 25.8054 7.8691 25.8023 7.5195C25.7993 7.16991 25.6591 6.83549 25.4118 6.58828C25.1646 6.34107 24.8302 6.20084 24.4806 6.1978C24.131 6.19477 23.7942 6.32916 23.5428 6.57204L16.0001 14.1147L8.45742 6.57204C8.20482 6.33516 7.86997 6.20586 7.52373 6.21148C7.17749 6.2171 6.84701 6.35721 6.60224 6.60216C6.35746 6.84711 6.21758 7.17768 6.21221 7.52393C6.20683 7.87018 6.33637 8.20494 6.57342 8.45737L14.1148 16L6.57209 23.5427C6.44474 23.6657 6.34317 23.8128 6.27329 23.9755C6.20341 24.1382 6.16663 24.3131 6.16509 24.4902C6.16355 24.6672 6.19729 24.8428 6.26433 25.0066C6.33137 25.1705 6.43037 25.3194 6.55556 25.4446C6.68075 25.5698 6.82962 25.6688 6.99348 25.7358C7.15735 25.8028 7.33292 25.8366 7.50996 25.835C7.687 25.8335 7.86196 25.7967 8.02463 25.7268C8.1873 25.657 8.33443 25.5554 8.45742 25.428L16.0001 17.8854Z",
    fill: "#3F46AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_9650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3cc5163c795bc3efe44f058097e3e56d.svg";
export { ForwardRef as ReactComponent };